import Heading from "@vfuk/core-heading";
import Image from "@vfuk/core-image";
import Spacing from "@vfuk/core-spacing";

import { Stack } from "../Stack";
import { getIconSource } from "../utils/countries";

interface CountryFlagWithNameProps {
  countryName: string;
  heading: string;
  justifyStyle?: string;
}

export const CountryFlagWithName = ({
  countryName,
  heading,
  justifyStyle,
}: CountryFlagWithNameProps) => {
  return (
    <Stack justifyContent={justifyStyle ? justifyStyle : "left"}>
      <Spacing spacingLevel={{ right: 3 }}>
        <Image
          sm={{
            src: getIconSource(countryName),
          }}
          alt={countryName}
        />
      </Spacing>
      <Spacing spacingLevel={{ right: 6 }}>
        <Heading noMargin size={1} weight={1}>
          {heading}
        </Heading>
      </Spacing>
    </Stack>
  );
};
